import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { categoriesService } from "./categories.service"
import type { CreateCategoryInput, UpdateCategoryInput } from "@montatec/contracts"
import { CacheKeys } from "../../../shared/consts/keys.consts"

export function useCategories() {
    return useQuery({
        queryKey: CacheKeys.categories,
        queryFn: categoriesService.get,
    })
}

export function useCategoriesMutations() {
    const qc = useQueryClient()
    
    const createCategory = useMutation({
        mutationFn: (data : CreateCategoryInput) => categoriesService.create(data),
        onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.categories }),
    })

    const updateCategory = useMutation({
        mutationFn: ({id, data} : {id: number, data: UpdateCategoryInput}) => categoriesService.update(id, data),
        onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.categories }),
    })
    
    const deleteCategory = useMutation({
        mutationFn: categoriesService.delete,
        onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.categories }),
    })

    return { createCategory, updateCategory, deleteCategory }
}
